import React, { PureComponent } from 'react';
import Loadable from 'react-loadable';
import AuthenticationLogin from '../components/AuthenticationLogin';
import AuthenticationNewPassword from '../components/AuthenticationNewPassword';
import AuthenticationForgotPassword from '../components/AuthenticationForgotPassword';
import AuthenticationCheckSMSPinCode from '../components/AuthenticationCheckSMSPinCode';
import AuthenticationTwoStep from '../components/AuthenticationTwoStep';
import { AuthenticationErrorMessage } from '../components/AuthenticationMessage/AuthenticationErrorMessage';
import { actionTypeEnum } from '../consts';
import CloakLoading from '../../../components/CloakLoading';

const LoadableAuthenticationDocumentPersonalization = Loadable({
	loader: () => import('../components/AuthenticationDocumentPersonalization'),
	loading: () => <CloakLoading />,
});

const AuthenticationActionSwitcher = (OriginalComponent) =>
	class extends PureComponent {
		state = {
			actionType: null,
		};

		static getDerivedStateFromProps(nextProps, prevState) {
			if (!prevState.actionType) {
				return {
					actionType: nextProps.authenticationInitialData.action,
				};
			}

			return null;
		}

		get currentFormByActionType() {
			const { actionType } = this.state;
			const { authenticationInitialData, portalData } = this.props;
			const generalComponentProps = {
				authenticationSetActionType: this.authenticationSetActionType,
				authenticationInitialData,
				actionType,
				portalData,
			};

			switch (actionType) {
				case actionTypeEnum.FORGOT_PASSWORD_FORM:
					return <AuthenticationForgotPassword {...generalComponentProps} />;
				case actionTypeEnum.NEW_PASSWORD:
				case actionTypeEnum.SET_PASSWORD:
					return <AuthenticationNewPassword {...generalComponentProps} />;
				case actionTypeEnum.LOGIN:
				case actionTypeEnum.LOGIN_FORM:
				case actionTypeEnum.LOGIN_FORM_GET:
				case actionTypeEnum.MULTIPLE_ORGANIZATION_CONFLICT:
					return (
						<AuthenticationLogin
							{...generalComponentProps}
							fetchAuthData={this.props.fetchAuthData}
						/>
					);
				case actionTypeEnum.DOCUMENT_PERSONALIZATION:
					return <LoadableAuthenticationDocumentPersonalization {...generalComponentProps} />;
				case actionTypeEnum.TWO_FACTOR_AUTH_REQUIRED:
				case actionTypeEnum.CHECK_AUTH_CODE:
				case actionTypeEnum.TWO_FACTOR_AUTH_VERIFIED:
					return <AuthenticationTwoStep {...generalComponentProps} />;
				case actionTypeEnum.CHECK_SMS_PIN_CODE_REGISTER_PASSWORD:
				case actionTypeEnum.CHECK_SMS_PIN_CODE_2FA:
				case actionTypeEnum.CHECK_SMS_PIN_CODE_2FA_SETUP:
					return <AuthenticationCheckSMSPinCode {...generalComponentProps} />;
				case actionTypeEnum.WRONG_DEEPLINK:
				case actionTypeEnum.WRONG_LOGIN_USE_ADFS:
				case actionTypeEnum.WRONG_LOGIN_USE_AZURE_AD:
				case actionTypeEnum.SESSION_EXPIRED:
				case actionTypeEnum.CAN_NOT_SEND_SMS:
				case actionTypeEnum.WRONG_PIN_CODE:
				case actionTypeEnum.PIN_CODE_ATTEMPTS_EXCEEDED:
				case actionTypeEnum.CHECK_CODE_ATTEMPTS_EXCEEDED:
				case actionTypeEnum.PERSONAL_DATA_NOT_FOUND:
				case actionTypeEnum.SORRY_AN_ERROR_OCCURRED:
					return <AuthenticationErrorMessage {...generalComponentProps} />;
				default:
					return null;
			}
		}

		authenticationSetActionType = (actionType) => {
			this.setState({
				actionType,
			});
		};

		render() {
			return (
				<OriginalComponent
					{...this.state}
					{...this.props}
					authenticationSetActionType={this.authenticationSetActionType}
					currentFormByActionType={this.currentFormByActionType}
				/>
			);
		}
	};

export default AuthenticationActionSwitcher;
